export default "__VITE_ASSET__CUGkyH8k__"